import React from "react";
import CartHeader from "./CartHeader";
import Icon from "../../../components/ui/Icon";
import Button from "../../../components/ui/Button";
import { PageBackground, PageShell, Card, IconBadge, Message } from "./EmptyCartState.styles";

interface EmptyCartStateProps {
  onClearCart: () => void;
  onAddItems: () => void;
}

export default function EmptyCartState({ onClearCart, onAddItems }: EmptyCartStateProps) {
  return (
    <PageBackground>
      <PageShell>
        <CartHeader count={0} onClearCart={onClearCart} />
        <Card>
          <IconBadge>
            <Icon name="bag" size={34} />
          </IconBadge>
          <Message>Nenhum item no carrinho</Message>
          <Button variant="primary" onClick={onAddItems}>
            Adicionar itens
          </Button>
        </Card>
      </PageShell>
    </PageBackground>
  );
}
